import { RouteObject } from 'react-router-dom';
import MeterFormatDashboard from './components/MeterReadFormat/MeterFormatDashboard';
import AddEditForm from './components/MeterReadFormat/AddEditForm';
import FormatDetailView from './components/MeterReadFormat/FormatDetailView';
import MeterReaderManagement from './components/ServiceExecutives/MeterReaderManagement';
import MeterReadersCodeLanding from './components/MeterReadersCode/MeterReadersCodeLanding';

export interface mxSettingsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxSettingsRoute[];
}

export const mxSettingsRoutes: mxSettingsRoute[] = [
  {
    path: 'mx/settings/meterread-format',
    // auth: true,
    element: <MeterFormatDashboard />
  },
  {
    path: 'mx/settings/meterread-format/add',
    // auth: true,
    element: <AddEditForm />
  },
  {
    path: 'mx/settings/meterread-format/edit/:id',
    // auth: true,
    element: <AddEditForm />
  },
  {
    path: 'mx/settings/meterread-format/view/:id',
    // auth: true,
    element: <FormatDetailView />
  },
  {
    path: 'mx/settings/service-executive',
    // auth: true,
    element: <MeterReaderManagement />
  },
  {
    path: 'mx/settings/meter-readers-code',
    // auth: true,
    element: <MeterReadersCodeLanding />
  },
];